package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWhy_didnt_i_receive_coins_after_inviting_to_registerPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/why_didnt_i_receive_coins_after_inviting_to_register.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/why-didnt-i-receive-coins-after-inviting-to-register")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Why_didnt_i_receive_coins_after_inviting_to_registerPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("why-didn-t-i-receive-coins-after-inviting-to-register") }) {
        org.jetbrains.compose.web.dom.Text("Why didn't I receive coins after inviting to register?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are a few reasons why you may not get coins after inviting someone to register:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("You didn't use the affiliate link to invite them:")
            }
            org.jetbrains.compose.web.dom.Text(" A regular invite without the affiliate user in the request will not give you coins.")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" You can copy the affiliate link directly from ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/affiliate") {
                org.jetbrains.compose.web.dom.Text("https://bot-hosting.net/panel/affiliate")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("The user is already registered in the hosting:")
            }
            org.jetbrains.compose.web.dom.Text(" You can check by typing the user ID of the user you invited in the search bar for the server. It should show the welcome channel message with the date when they joined.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Please note:")
            }
            org.jetbrains.compose.web.dom.Text(" the list may not have all the users and join messages.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("The user account age is lower than expected:")
            }
            org.jetbrains.compose.web.dom.Text(" some people may create alt accounts to invite themselves and get coins.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("The user account is detected as fraudulent:")
            }
            org.jetbrains.compose.web.dom.Text(" we cannot and will not release further information about how accounts are detected as fraudulent for obvious reasons.")
        }
    }
}
